import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CompanyContact } from '../../models/Contacts/CompanyContact';
import { PersonalDeContactoService } from '../../../services/personal-de-contacto.service';


@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: false
})
export class ContactsComponent implements OnInit {

  public contactForm: UntypedFormGroup
  public empresaReadOnly = false
  public hideOnAdding = false
  private emailPattern: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
  constructor
    (
      public _dialogRef: MatDialogRef<ContactsComponent>,
      public _fb: UntypedFormBuilder,
      private _sharedService: SharedService,
      private _personalDeContactoService: PersonalDeContactoService,
      @Inject(MAT_DIALOG_DATA)
      private _dialogData: CompanyContact
    ) {
    //creates the form with default values
    this.createContactForm(_dialogData);

    //if the id is not 0, then its an Update else an Add 
    if (_dialogData.id !== 0) {
      this.contactForm.patchValue({
        Id: _dialogData.id,
        Empresa: _dialogData.empresaNombre,
        Nombre: _dialogData.nombre,
        Cargo: _dialogData.cargo,
        Email: _dialogData.email,
        Telefono: _dialogData.telefono,
        Movil: _dialogData.movil,
        Comentarios: _dialogData.comentarios
      });
      this.empresaReadOnly = true
      this.hideOnAdding = true
    } else {
      this.empresaReadOnly = false
      this.hideOnAdding = false
    }
  }

  ngOnInit(): void {
  }

  createContactForm(contact: any) {
    this.contactForm = this._fb.group({
      Id: [0],
      EmpresaId: [contact.empresaId],
      Empresa: [''],
      Nombre: ['', Validators.required],
      Cargo: [''],
      Email: ['', Validators.pattern(this.emailPattern)],
      Telefono: [''],
      Movil: [''],
      Comentarios: ['']
    })
  }

  public onSubmit() {
    this.contactForm.markAllAsTouched();
    this.contactForm.updateValueAndValidity();

    if (this.contactForm.valid) {
      //add data  
      if (this.contactForm.value.Id === 0) {
        this.addContact()
      } else {
        //update        
        this.updateContact()
      }
    }
  }

  cancel(submitSuccess: boolean) {
    this._dialogRef.close(submitSuccess == null ? false : submitSuccess);
  }

  private addContact() {
    this._personalDeContactoService.AddContact(this.contactForm.value)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Guardado con éxito', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al crear', 'Okay', 2000);
        }

      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }

  private updateContact() {
    this._personalDeContactoService.UpdateContact(this.contactForm.value)
      .subscribe(res => {
        if (res.code === 0) {
          this._sharedService.ShowSnackBar('Actualizado con éxito	', 'Okay', 2000);
          this.cancel(true)
        } else {
          this._sharedService.ShowSnackBar('Error al guardar', 'Okay', 2000);
        }
      }, err => {
        this._sharedService.ShowSnackBar('Se produjo un error', 'Okay', 2000);
      });
  }











}
